export const isPortalAccess = () => {
  return ["/customer-portal", "/tracking"].some((path) =>
    window.location.pathname.includes(path)
  );
};
